import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ChatStateService } from 'src/app/services/chat-state.service';
import { FileValidationService } from 'src/app/services/file-validation.service';

@Component({
  selector: 'app-option-style',
  templateUrl: './option-style.component.html',
  styleUrls: ['./option-style.component.scss']
})
export class OptionStyleComponent implements OnInit, OnDestroy {
  chatMode: string = 'creative';

  activeFeatureList: any = [];
  selectedFeature: any;
  subFeatureList!: Subscription;
  subUploadFile!: Subscription;
  subFeature!: Subscription;

  uploadFile: any;

  conversationStyle: any = [
    {
      tilte: 'Creative', mode: 'creative', config: {
        "top_p": 0.85, "temperature": 0.7, "model": "gpt4", "max_tokens": 4000, "chat_style": false, "style_guide": true
      }
    },
    {
      tilte: 'Neutral', mode: 'neutral', config: {
        "top_p": 0.95, "temperature": 0.5,  "model": "gpt4", "max_tokens": 2000, "chat_style": false, "style_guide": true
      }
    },
    {
      tilte: 'Specific', mode: 'specific', config: {
        "top_p": 0.95, "temperature": 0.3,  "model": "gpt4",  "max_tokens": 1000, "chat_style": false, "style_guide": true
      }
    }
  ]



  constructor(
    private chatStateService: ChatStateService,
    private fileValidationService: FileValidationService,
    private router: Router,
   
  ) { }


  ngOnInit(): void {
    this.updateChatMode(this.conversationStyle[0]);

    this.subUploadFile = this.chatStateService.activeFeatureUplaodFile.subscribe((res: any) => {
     if(res.length > 0){
      this.uploadFile = res;     
     }
    })

    this.subFeature = this.chatStateService.featureState.subscribe((res: any) => {
      this.selectedFeature = res;
    })


    this.subFeatureList = this.chatStateService.activeFeaturState.subscribe((res: any) => {
      this.selectedFeature = '';
      this.activeFeatureList = res || [];
      // console.log('check this'+ res || []);
    })
  }

  updateChatMode(style: any) {
    this.chatMode = style.mode;
    this.chatStateService.chatConfigDefaultState.next(style?.config);
    this.chatStateService.chatConfigState.next(style?.config);
    this.chatStateService.chatModeState.next(style?.mode);
  }


  submitOption(feature: any) {

    this.chatStateService.featureState.next(feature?.name);

    console.log('this.file',this.uploadFile)

    switch (feature?.name) {
    case 'byod':  this.chatStateService.byodFileUpload.next(this.uploadFile);
    if(!this.fileValidationService.byodFileValidation(this.uploadFile)) {
     this.uploadFile = [];
     this.chatStateService.activeFeatureUplaodFile.next(this.uploadFile);
    }
      this.activeFeatureList =[
        { title: 'Summarize', match: false, name: 'byod', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg files allowed. max 16MB allowed', value: ['pdf', 'PDF', 'txt', 'TXT', 'pptx', 'PPTX', 'pptx', 'docx', 'DOCX', 'xlsx', 'XLXS', 'csv', 'CSV', 'xls', 'XLS', 'jpeg', 'png', 'jpg'] },
        { title: 'Translate', match: false, name: 'translate', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg and .tiff files allowed max 16MB allowed', value: ['txt', 'xlsx', 'xls', 'pdf', 'PDF', 'pptx', 'PPTX', 'ppt', 'pptx', 'doc', 'DOC', 'docx', 'DOCX', 'png', 'jpeg', 'jpg', 'PNG', 'tif', 'tiff'] },
        { title: 'Transcribe', match: false, name: 'transcribe', max: '.mp3, .mp4, .m4a, .m4v, .wav files allowed max 50MB allowed', value: ['mp3', 'mp4', 'm4a', 'm4v', 'wav'] }
      ];
        break;

    case 'translate':  this.chatStateService.translateFileUpload.next(this.uploadFile);
    if(!this.fileValidationService.translateFileValidation(this.uploadFile)) {
       this.uploadFile = [];
       this.chatStateService.activeFeatureUplaodFile.next(this.uploadFile);
      }
      this.activeFeatureList =  [
        { title: 'Summarize', match: false, name: 'byod', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg files allowed. max 16MB allowed', value: ['pdf', 'PDF', 'txt', 'TXT', 'pptx', 'PPTX', 'pptx', 'docx', 'DOCX', 'xlsx', 'XLXS', 'csv', 'CSV', 'xls', 'XLS', 'jpeg', 'png', 'jpg'] },
        { title: 'Translate', match: false, name: 'translate', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg and .tiff files allowed max 16MB allowed', value: ['txt', 'xlsx', 'xls', 'pdf', 'PDF', 'pptx', 'PPTX', 'ppt', 'pptx', 'doc', 'DOC', 'docx', 'DOCX', 'png', 'jpeg', 'jpg', 'PNG', 'tif', 'tiff'] },
        { title: 'Transcribe', match: false, name: 'transcribe', max: '.mp3, .mp4, .m4a, .m4v, .wav files allowed max 50MB allowed', value: ['mp3', 'mp4', 'm4a', 'm4v', 'wav'] }
      ];
        break;

    case 'transcribe':  this.chatStateService.transcribeFileUpload.next(this.uploadFile);
    if(!this.fileValidationService.transcribeFileValidation(this.uploadFile)) {
      this.uploadFile = [];
      this.chatStateService.activeFeatureUplaodFile.next(this.uploadFile);
     }

      this.activeFeatureList =  this.activeFeatureList =  [
        { title: 'Summarize', match: false, name: 'byod', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg files allowed. max 16MB allowed', value: ['pdf', 'PDF', 'txt', 'TXT', 'pptx', 'PPTX', 'pptx', 'docx', 'DOCX', 'xlsx', 'XLXS', 'csv', 'CSV', 'xls', 'XLS', 'jpeg', 'png', 'jpg'] },
        { title: 'Translate', match: false, name: 'translate', max: '.pdf, .txt, .pptx, .docx, .xlsx,.jpg, .png, .jpeg and .tiff files allowed max 16MB allowed', value: ['txt', 'xlsx', 'xls', 'pdf', 'PDF', 'pptx', 'PPTX', 'ppt', 'pptx', 'doc', 'DOC', 'docx', 'DOCX', 'png', 'jpeg', 'jpg', 'PNG', 'tif', 'tiff'] },
        { title: 'Transcribe', match: false, name: 'transcribe', max: '.mp3, .mp4, .m4a, .m4v, .wav files allowed max 50MB allowed', value: ['mp3', 'mp4', 'm4a', 'm4v', 'wav'] }
      ];
        break;

      default: {
        this.chatStateService.featureState.next('chatGPT');
        this.router.navigate(['/chat']);
      }
    }


   
    this.router.navigate([feature?.name]);
  }



  ngOnDestroy(): void {
    this.subFeatureList?.unsubscribe();
    this.subUploadFile?.unsubscribe();
    this.subFeature?.unsubscribe();
  }



}
